import React from 'react';

const Input = ({ label, error, ...props }) => {
  return (
    <div style={{ marginBottom: '15px' }}>
      {label && (
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
          {label}
        </label>
      )}
      <input
        style={{
          width: '100%',
          padding: '10px',
          border: `1px solid ${error ? '#dc3545' : 'var(--color-border)'}`,
          borderRadius: '4px',
          fontSize: '16px',
          background: 'var(--color-input-bg)',
          color: 'var(--color-input-text)',
        }}
        {...props}
      />
      {error && (
        <span style={{ color: '#dc3545', fontSize: '14px', marginTop: '5px', display: 'block' }}>
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
